import { HttpClient } from "@angular/common/http";
import { Injectable, inject } from "@angular/core";

import { AjsResponse, wrapAjs } from "../ajs-response";
import { buildParams } from "../http-params.util";

/**
 * SubscriptionsApiService (Angular 18).
 *
 * Replaces apps/b2b-ui/common/services/api/subscriptionsApi/subscriptionsApi.service.js.
 *
 * All endpoints are v2; the legacy used ApiVersionFactory to rewrite `/v1/`
 * → `/v2/`, hardcoded here.
 *
 * Note: `optOut()` carries `?saleChannel=insideSalesIndividual` baked into
 * the legacy URL — preserved verbatim.
 */
const RECURRING_MEMBERSHIP_BASE_V2 = "/v2/api/recurring/membership";
const RECURRING_PAYMENT_PLAN_BASE_V2 = "/v2/api/recurring/paymentplan";
const RECURRING_PAYMENT_PLAN_CUSTOMER_BASE_V2 =
  "/v2/api/recurringpaymentplan/customer";

const SUBSCRIPTION_LIST_FIELDS = [
  "pageSize",
  "page",
  "sortField",
  "sortDirection",
  "startDate",
  "endDate",
  "status",
  "filterType",
] as const;

@Injectable({ providedIn: "root" })
export class SubscriptionsApiService {
  private readonly http = inject(HttpClient);

  list(props?: Record<string, unknown>): Promise<AjsResponse<unknown>> {
    return wrapAjs(
      this.http.get<unknown>(`${RECURRING_MEMBERSHIP_BASE_V2}/details`, {
        params: buildParams(props, SUBSCRIPTION_LIST_FIELDS),
      }),
    );
  }

  detail(id: number | string): Promise<AjsResponse<unknown>> {
    return wrapAjs(
      this.http.get<unknown>(`${RECURRING_MEMBERSHIP_BASE_V2}/${id}/details`),
    );
  }

  optOut(id: number | string): Promise<AjsResponse<unknown>> {
    return wrapAjs(
      this.http.put<unknown>(
        `${RECURRING_PAYMENT_PLAN_BASE_V2}/${id}/cancel?saleChannel=insideSalesIndividual`,
        null,
      ),
    );
  }

  readonly customer = {
    detail: (id: number | string): Promise<AjsResponse<unknown>> =>
      wrapAjs(
        this.http.get<unknown>(
          `${RECURRING_PAYMENT_PLAN_CUSTOMER_BASE_V2}/${id}`,
        ),
      ),
  };
}
